module.exports = __webpack_public_path__ + "img/logo_planner.6392fa3b.png";